import { createVar } from '~/theme';

/**
 * Clearance the design side panel adds so its first row is not covered by the
 * fixed next-step button. Smaller than the button itself, because every panel
 * tab header already contributes its own top padding.
 */
export const nextStepBtnClearance = createVar('layout-nextStepBtnClearance');

/**
 * Main content block padding, published so descendants can size themselves
 * against the viewport. Unit-bearing zeroes keep dependent calc() valid.
 */
export const mainPaddingBlockStart = createVar('layout-mainPaddingBlockStart');
export const mainPaddingBlockEnd = createVar('layout-mainPaddingBlockEnd');
